import { FC, useCallback, useMemo, useState } from "react";
import { Box, DialogActions, DialogContent, Switch, Typography } from "@material-ui/core";
import { closeDrawer } from "actions/drawerActions";
import { useDispatch } from "react-redux";
import { CustomButton } from "componentsNew/buttons/CustomButton";
import { TableColumnSettings } from "componentsNew/elements/TableColumnSettings";
import { useCustomDrawerStyles } from "../styles";
import { FLEET_REPORTS_TABLE_HADER_FILTER_COLUMNS } from "pages/FleetReports/tableData";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { fleetReportsSetFilter } from "actions/fleetReportsAction";

interface FleetReportsTableSettingsDrawerContentProps {}

export const FleetReportsTableSettingsDrawerContent: FC<
  FleetReportsTableSettingsDrawerContentProps
> = () => {
  const classes = useCustomDrawerStyles();
  const dispatch = useDispatch();
  const { fleetReportFilters } = useTypeSelectors((state) => state.fleetReports);
  const [showActual, setShowActual] = useState(fleetReportFilters.showActual);
  const [activeCols, setActiveCols] = useState<string[]>(fleetReportFilters?.activeColumns || []);

  const filterColumns = useMemo(() => FLEET_REPORTS_TABLE_HADER_FILTER_COLUMNS, []);

  const closenModal = () => dispatch(closeDrawer());

  const handleTogglePaths = useCallback((paths: string[]) => {
    if (!paths.length) return;
    setActiveCols((prev) => {
      const allSelected = paths.every((path) => prev.includes(path));
      if (allSelected) return prev.filter((path) => !paths.includes(path));
      return prev.concat(paths.filter((path) => !prev.includes(path)));
    });
  }, []);

  const handleFilterSubmit = () => {
    dispatch(fleetReportsSetFilter({
      activeColumns: activeCols,
      showActual: showActual,
    }));
    closenModal();
  };

  return (
    <>
      <DialogContent className={classes.drawerContent}>
        <Box className={classes.drawerSection}>
          <Box className={classes.horizontalBox}>
            <Typography style={{ fontWeight: 600 }}>Show Actual</Typography>
            <Switch checked={showActual} onChange={() => setShowActual(!showActual)} />
          </Box>
        </Box>
        <TableColumnSettings
          items={filterColumns}
          activeCols={activeCols}
          onTogglePaths={handleTogglePaths}
        />
      </DialogContent>
      <DialogActions className={classes.actionSection}>
        <Box className={classes.actionButtons}>
          <Box className={classes.actionButtons}>
            <Box className={classes.actionButtonsLeft}>
              <CustomButton buttonText={"Apply"} onClick={handleFilterSubmit} variant="contained" />
              <CustomButton buttonText={"Cancel"} onClick={closenModal} variant="text" />
            </Box>
          </Box>
        </Box>
      </DialogActions>
    </>
  );
};
